import React from 'react';
import { useSelector } from 'react-redux';
import {
	profileParams,
	profileDescription,
} from '@src/containers/ProfileVenue/selectors';
import VenueProfileComponent from '..';

const VenueFeaturesConnector = () => {
	const params = useSelector(profileParams);
	const description = useSelector(profileDescription);

	if (!params) {
		return null;
	}

	return (
		<VenueProfileComponent
			checkItems={params.list}
			textItems={params.text}
			specText={description}
		/>
	);
};

export default VenueFeaturesConnector;
